<template>
  <div  ref="pdfContent" id="pdf_viewer">
      <PDFViewerHeader
        class="pdf-header"
        :currentPage="currentPage"
        :numPages="numPages"
        :scale="scale"
        :increment="increment"
        :is_mobile="is_mobile"
        @close="closePdf"
        @updateScale="updateScale"
        @updateFit="updateFit"
        @goToPage="goToPage"
        @showPreview="showPreview"
      ></PDFViewerHeader>
      <div class="pdf-content" :hidden="numPages <= 0">
        <PDFPreviewer
          v-if="!is_mobile && pdf_data"
          v-show="preview"
          :url="url"
          :pdf_data="pdf_data"
          :currentPage="currentPage"
          :numPages="numPages"
          :inputPage="inputPage"
          @goToPage="goToPage"
        ></PDFPreviewer>
        <PDFDocument
          v-if="pdf_data"
          class="pdf-document"
          :class="{ 'preview-enabled': (preview && !is_mobile)}"
          :is_mobile="is_mobile"
          :url="url"
          :pdf_data="pdf_data"
          :currentPage="currentPage"
          :numPages="numPages"
          :scale="scale"
          :fit="fit"
          :inputPage="inputPage"
          numberPage
          @changeCurrentPage="updateCurrentPage"
          @updatePages="updatePages"
          @updateScale="updateScale"
          @isLoading="updateLoading"
        ></PDFDocument> 
        <v-progress-linear
          indeterminate
          color="primary"
          v-if="loading"
          class="pdf-loading"
        ></v-progress-linear>
      </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import PDFDocument from '@/components/pdf_viewer/new_components/PDFDocument';

import PDFViewerHeader from '@/components/pdf_viewer/new_components/PDFViewerHeader';
import PDFPreviewer from '@/components/pdf_viewer/new_components/PDFPreviewer';

export default {
  name: 'PDFViewer',
  components: {
    PDFDocument,
    PDFViewerHeader,
    PDFPreviewer,
  },
  props: {
    is_mobile: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String
    },
    pdf_data: {
      type: ArrayBuffer
    }
  },
  
  data() {
    return {
      documentError: null,
      page: 1,
      numPages: 0,
      rotate: 0,
      scale: 1.5,
      fit: '',
      increment: 0.25,
      preview: true,
      loading: false,
      inputPage: 0,
    };
  },

  computed: {
      ...mapGetters(['sitePath',]),
      pages() {
          return this.numPages > 0 ? [...Array(this.numPages).keys()].map(p => p+1) : [1];
      },
      currentPage() {
        return this.page;
      },
  },

  mounted(){
  },

  methods: {
      updatePages(pages){
        if (pages && this.numPages <= 0) {
          this.numPages = pages;
        }
      },
      updateCurrentPage(page) {
          this.page = page;
      },
      goToPage(page) {
        this.inputPage = page;
      },
      updateScale(scale) {
        this.scale = scale;
        this.fit = null;
      },
      updateFit(fit) {
        this.fit = fit;
      },
      showPreview () {
        this.preview = !this.preview;
        this.fit = 'overflow';
      },
      updateLoading(loading) {
        this.loading = loading;
      },
      closePdf() {
        this.$emit('closePdf')
      },
  },
  watch:{
    is_mobile() {
      if(this.is_mobile) {
        this.updateFit('width');
      }
    },
    url() {
      if (this.url) {
        this.loading = false;
      } else {
        this.loading = true;
      }
    }
  },
}
</script>
<style scoped lang="scss">
@import "@/sass/pdf.scss";
  @media print {
    #pdf_viewer {
        display: none;
    }
  }
</style>